import React from 'react';
import { FormHelperText, Switch, FormControl } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useField } from 'react-final-form-hooks';

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 46,
    height: 26,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 4,
    color: theme.palette.grey[400],
    '&$checked': {
      transform: 'translateX(20px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: '#fcc52e',
        borderColor: '#dba335',
      },
    },
  },
  thumb: {
    width: 18,
    height: 18,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 26 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);

export default function ({
  form,
  name,
  label,
  icon,
  type,
  children,
  hint,
  options,
  valueIfTrue = true,
  valueIfFalse = false,
  hidden,
  ...props
}) {
  const field = useField(name, form);
  const onChange = (event) => {
    field.input.onChange(event.target.checked ? valueIfTrue : valueIfFalse);
  };
  const value = field.input.value === valueIfTrue;

  if (hidden) {
    return null;
  }

  return (
    <FormControl margin="normal" fullWidth>
      <div className="" style={{ marginTop: '4px', marginBottom: '1px' }}>
        <small
          className="mr-2 px-1 position-absolute bg-white nowrap"
          style={{ top: '-10px' }}
        >
          {label}
        </small>
        <div className="flex px-1 pt-2">
          <AntSwitch
            checked={value}
            onChange={onChange}
            className="fullwidth"
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
        </div>
      </div>
      {field.meta.touched && field.meta.error ? (
        <FormHelperText>{field.meta.error}</FormHelperText>
      ) : null}
    </FormControl>
  );
}
